export default __webpack_public_path__ + "static/media/star-filled.8a1277be.png";